import BasePage from '@/found/components/table_page';

export default {
  name: 'area_fee',
  extends: BasePage,
  data() {
    return {};
  },
  components: {

  },
  async created() {
    await this.getConfigList('area_fee');
  },
  methods: {

  },
};
